import styled from 'styled-components';
import { container, flexPosition } from '../../styles/mixins';
import { DANGER_COLOR } from '../../styles/variables';

export const Container = styled.div``;

export const Content = styled.div`
  ${container()}
  padding-bottom: 100px;
`;

export const Header = styled.div`
  background-color: #fff;
  ${flexPosition({ align: 'center' })}
  width: 100%;
  height: 100px;
`;

export const Body = styled.div``;

export const Box = styled.div`
  ${flexPosition({ align: 'start', justify: 'space-between' })}
  width: 100%;
  padding: 30px;
  margin-top: 35px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.05);
  border: ${({ error }) => (error ? `2px solid ${DANGER_COLOR}` : 'none')};
`;

export const Form = styled.form``;

export const RadioContainer = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const BoxInline = styled.div`
  ${flexPosition({ align: 'top', justify: 'space-between' })}
  ${Box} {
    margin-right: 30px;
    height: 400px;
    padding: 30px 15px;
    &:last-child {
      margin-right: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/screens/CreateMenuUhuu/style.js